import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=5a4625fb&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=ts"
export * from "./UserEdit.vue?vue&type=script&lang=ts"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=5a4625fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4625fb",
  null
  
)

export default component.exports